export default __webpack_public_path__ + "static/media/480_private03-jp-web.a4daf18b.png";